import { useRef, useState } from 'react';

interface IUseConfirmDialogReturn {
  isOpen: boolean;
  message: string;
  isLoading: boolean;
  show: (message: string, onConfirm: () => Promise<void>) => void;
  confirm: () => Promise<void>;
  cancel: () => void;
}

const useConfirmDialog = (): IUseConfirmDialogReturn => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const onConfirmRef = useRef<(() => Promise<void>) | null>(null);

  const show = (message: string, onConfirm: () => Promise<void>) => {
    setMessage(message);
    onConfirmRef.current = onConfirm;
    setIsOpen(true);
  };

  const confirm = async () => {
    if (!onConfirmRef.current) return;

    setIsLoading(true);

    try {
      await onConfirmRef.current();
    } finally {
      setIsLoading(false);
      setIsOpen(false);
    }
  };

  const cancel = () => {
    setIsOpen(false);
  };

  return {
    isOpen,
    message,
    isLoading,
    show,
    confirm,
    cancel,
  };
};

export default useConfirmDialog;
